export default __webpack_public_path__ + "static/media/other.cecfd177.jpg";